import React from 'react';
import proptypes from 'prop-types';
import { Link } from '@one-thd/sui-atomic-components';
import { Paint, CounterTop, Drill } from '@one-thd/sui-icons';

const AddMaterialsToYourList = ({ url }) => {
  return (
    <div
      className="sui-flex sui-items-center
    sui-justify-between sui-gap-4 sui-bg-subtle
    sui-rounded-md sui-p-3 @sm:sui-py-10"
    >
      <Link href={url} variant="body-sm" color="medium">
        Add materials to your list
      </Link>
      <div className="sui-flex sui-gap-4 sui-items-center">
        <Drill size="regular" color="medium" />
        <CounterTop size="regular" color="medium" />
        <Paint size="regular" color="medium" />
      </div>
    </div>
  );
};

AddMaterialsToYourList.propTypes = {
  url: proptypes.string.isRequired
};

export { AddMaterialsToYourList };
